'use client';

import { FC } from 'react';
import RecipeDrawer from './RecipeDrawer';
import IngredientSheet from './IngredientSheet';

type RecipeSheetStackProps = {
  organization_id: string;
  canEditRecipes: boolean;
};

/**
 * Mounted once, globally, for the whole authenticated app shell (see
 * (application)/[organization_id]/layout.tsx) rather than per-page -- both
 * pieces read their open/closed state from the current URL's
 * `?recipe=&ingredient=` params (useSheetStackParams), so they work no
 * matter which page a "recipe"/"ingredient" link/search-result points at.
 */
const RecipeSheetStack: FC<RecipeSheetStackProps> = ({
  organization_id,
  canEditRecipes
}) => (
  <>
    <RecipeDrawer
      organization_id={organization_id}
      canEditRecipes={canEditRecipes}
    />
    <IngredientSheet organization_id={organization_id} />
  </>
);

export default RecipeSheetStack;
